import React, { useState, useEffect } from "react";
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import { ReactComponent as MagnificationLogo } from '../../img/magnificationlensicon.svg'
import { ReactComponent as FilterLogo } from '../../img/filtericon.svg'
import { ReactComponent as PlusIcon } from '../../img/plusicon.svg'
import { ReactComponent as VerticalLine } from '../../img/verticalline.svg'
import { instance2 } from "../../utils/axiosInstance";

export default function UserTable({ onAddAdmin, onEditAdmin, refreshKey }) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const [searchQuery, setSearchQuery] = useState(""); // State for search input

    const fetchData = async () => {
      try {
        const response = await instance2.get("admins"); // Use instance2 for the API call
  
        const apiData = response.data; // Access the data property from Axios response
  
        const formattedData = apiData.map((item) => ({
          id: item.id,
          nama: item.username || "N/A",
          namalengkap: item.name || "N/A",
          noHp: item.phone || "N/A",
          peran: item.role_name || "N/A",
          peran_id: item.role_id || "N/A",
          dapur_id: item.kitchen_id || "N/A",
          dapur_name: item.kitchen_name || "N/A",
          lokasi_id: item.location_id || "N/A",
          lokasi_name: item.location_name || "N/A",
          status: item.active ? "Aktif" : "Non Aktif",
          role_id: item.role_id,
        }));
  
        setData(formattedData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };
  
  useEffect(() => {
    fetchData();
  }, [refreshKey]);
  
  const handleSort = (key) => {
    const newDirection =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";

    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return newDirection === "asc" ? -1 : 1;
      if (a[key] > b[key]) return newDirection === "asc" ? 1 : -1;
      return 0;
    });

    setData(sortedData);
    setSortConfig({ key, direction: newDirection });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "▲" : "▼";
    }
    return "";
  };


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
// Filter data based on search query
const filteredData = data.filter(
  (item) =>
    item.nama.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.noHp.includes(searchQuery) ||
    item.peran.toLowerCase().includes(searchQuery.toLowerCase())
);

const handleEdit = (user) => {
  onEditAdmin(user); // Pass the selected user data to the parent component
};
       
         const totalPages = Math.ceil(filteredData.length / itemsPerPage);
         const paginatedData = filteredData.slice(
           (currentPage - 1) * itemsPerPage,
           currentPage * itemsPerPage
         );
       
         const handlePreviousPage = () => {
           if (currentPage > 1) setCurrentPage(currentPage - 1);
         };
       
         const handleNextPage = () => {
           if (currentPage < totalPages) setCurrentPage(currentPage + 1);
         };
       
         // Determine which page numbers to show
         let pageNumbers = [];
         const maxVisiblePages = 5;
       
         if (totalPages <= maxVisiblePages) {
           pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
         } else {
           if (currentPage <= 3) {
             // Near the beginning
             pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
           } else if (currentPage >= totalPages - 2) {
             // Near the end
             pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
           } else {
             // In the middle
             pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
           }
         }
return (
  <div className="mx-4 md:mx-20 py-5 text-xs">
    <div className="flex flex-col md:flex-row border-t border-b border-gray-300 px-4 py-2 items-center justify-between gap-4 mb-4">
      <div className="flex px-4 py-2 rounded-[50px] flex-row justify-center items-center gap-2 w-full md:w-auto">
        <div className="rounded-full p-2 bg-white text-gray-400 shadow-lg flex items-center w-full md:w-auto">
          <MagnificationLogo className="h-6 w-6" />
          <VerticalLine className="mx-1" />
                    <input
                        type="text"
                        placeholder="Telusuri pengguna berdasarkan nama, no hp atau peran"
                        className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-sm"
                        style={{ width: `${"Telusuri pengguna berdasarkan nama, no hp atau peran".length}ch` }} 
                        value={searchQuery} // Controlled input
                        onChange={(e) => setSearchQuery(e.target.value)} // Update search query
                    />
        </div>
        {/* <div className="text-gray-400">
          <FilterLogo />
        </div> */}
      </div>
      <div className="flex flex-col md:flex-col items-center justify-center gap-2 w-full md:w-auto">
        <div className="flex items-center w-full md:w-auto">
          <div className="border-t border-transparent w-full md:flex-1"></div>
          <button
            className="group flex items-center justify-center w-full md:w-auto border border-black bg-transparent pe-2 rounded-[25px] hover:bg-[#FFA101] hover:text-white hover:border-white transition-colors duration-100 cursor-pointer"
            onClick={onAddAdmin}
          >
            <div className="uppercase font-medium p-4 text-center">Tambah Admin Baru</div>
          </button>
          <div className="border-t border-transparent w-full md:flex-1"></div>
        </div>
      </div>
    </div>

    {isLoading ? (
      <div className="text-center py-4">Loading...</div>
    ) : error ? (
      <div className="text-center py-4 text-red-500">Tidak dapat menerima data</div>
    ) : (
      <>
        <div className="overflow-x-auto">
          <table className="table-fixed w-full border-collapse text-left">
            <thead>
              <tr className="bg-white">
              <th
                  className="w-[25px] lg:w-[50px] border-b border-gray-300 px-4 py-2 cursor-pointer rounded-tl-[15px] text-xxs md:text-xxs lg:text-base"
                >
                  No.
                </th>
                <th
                  className="border-b border-gray-300 px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("namalengkap")}
                >
                  Nama Lengkap <span className="float-right">{getSortArrow("namalengkap")}</span>
                </th>
                <th
                  className="border-b border-gray-300 px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("nama")}
                >
                  Nama Pengguna <span className="float-right">{getSortArrow("nama")}</span>
                </th>
                <th
                  className="border-b border-gray-300 px-4 py-2 text-center cursor-pointer text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("noHp")}
                >
                  No HP <span className="float-right">{getSortArrow("noHp")}</span>
                </th>
                <th
                  className="border-b border-gray-300 px-4 py-2 text-center cursor-pointer text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("peran")}
                >
                  Peran <span className="float-right">{getSortArrow("peran")}</span>
                </th>
                <th
                  className="border-b border-gray-300 px-4 py-2 text-center cursor-pointer text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("status")}
                >
                  Status <span className="float-right">{getSortArrow("status")}</span>
                </th>
                <th className="border-b border-gray-300 px-4 py-2 rounded-tr-[15px] text-center text-xxs md:text-xxs lg:text-base">
                  Tindakan
                </th>
              </tr>
            </thead>
            <tbody>
                  {[
            ...paginatedData,
            ...Array.from({ length: itemsPerPage - paginatedData.length }).map((_, index) => ({
              empty: true, // Add an "empty" object for invisible rows
            })),
          ].map((user, index) => (
            <tr
            key={user.id}
            className={`hover:bg-gray-200 ${
              index % 2 === 0 ? "bg-bg-gray-100" : "bg-white"
            } ${user.empty ? "invisible border-b border-transparent" : "border-b border-gray-300"}`}
          >
                  <td className="w-[25px] lg:w-[50px] px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                  {index + 1 + (currentPage - 1) * itemsPerPage}</td>
                  <td className="px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">{user.namalengkap}</td>
                  <td className="px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">{user.nama}</td>
                  <td className="py-2 text-center text-xxs md:text-xxs lg:text-base">{user.noHp}</td>
                  <td className="py-2 text-center text-xxs md:text-xxs lg:text-base">{user.peran}</td>
                  <td className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">{user.status}</td>
                  <td className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
                    <div className="flex justify-center items-center gap-2">
                      <button
                        className="text-gray-500 p-2 rounded hover:bg-blue-400"
                        onClick={() => handleEdit(user)}
                      >
                        <EditIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                      </button>
                      <button
                        className="text-gray-500 p-2 rounded hover:bg-red-400"
                        onClick={() => alert(`Delete data for ${user.nama}`)}
                      >
                        <TrashIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
{/* Pagination Controls */}
<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
      </>
    )}
  </div>
);

}
